import React from 'react';

// Shown instead of a plain error banner when an approval is blocked because
// the approver's own configured limit doesn't cover the deal. Informative,
// not alarming - the deal isn't broken, it just needs a different approver
// (or a higher limit) to proceed. Middle Office is notified server-side the
// moment this happens (see services/approvalLimitService.js on the backend).
export default function LimitExceededNotice({ info, onDismiss }) {
  if (!info) return null;
  const { message, yourLimit, dealAmount, eligibleApprovers } = info;
  return (
    <div
      style={{
        background: '#fff8e1',
        border: '1px solid #ffca28',
        borderRadius: 6,
        padding: '12px 16px',
        marginBottom: 16
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <strong style={{ color: '#8a6d00' }}>Approval limit exceeded</strong>
        {onDismiss && (
          <button
            type="button"
            onClick={onDismiss}
            style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: 16, lineHeight: 1, color: '#8a6d00' }}
            aria-label="Dismiss"
          >
            ×
          </button>
        )}
      </div>
      <div style={{ marginTop: 4, color: '#5c4a00' }}>
        {message || `Your approval limit (${Number(yourLimit || 0).toLocaleString()}) is insufficient for this deal (${Number(dealAmount || 0).toLocaleString()}).`}
      </div>
      <div style={{ marginTop: 8, color: '#5c4a00' }}>
        {Array.isArray(eligibleApprovers) && eligibleApprovers.length > 0 ? (
          <>
            <div style={{ fontWeight: 600, marginBottom: 2 }}>Eligible approver(s) at this stage:</div>
            <ul style={{ margin: 0, paddingLeft: 20 }}>
              {eligibleApprovers.map((a) => (
                <li key={a.id}>
                  {a.username}
                  {a.per_deal_limit ? ` (limit: ${Number(a.per_deal_limit).toLocaleString()})` : ' (no limit configured)'}
                </li>
              ))}
            </ul>
          </>
        ) : (
          <div>No other assigned approver at this stage currently has a sufficient limit — the limit may need to be raised.</div>
        )}
        <div style={{ marginTop: 6, fontStyle: 'italic' }}>Middle Office has been notified.</div>
      </div>
    </div>
  );
}
